import { Directive, Input, Type, inject } from '@angular/core';

import { MenuContentItem, MenuSection, Page, UtilsService, trackByProp } from '@frontend/vanilla/core';
import { ProductMenuService } from '@frontend/vanilla/shared/product-menu';

@Directive()
export abstract class ProductMenuItemBase {
    @Input() item: MenuContentItem;

    readonly MenuSection = MenuSection;
    readonly trackByProp = trackByProp<MenuContentItem>('id');

    protected readonly productMenuService = inject(ProductMenuService);
    protected readonly page = inject(Page);

    get v2(): boolean {
        return this.productMenuService.v2;
    }

    get useFastIconType(): boolean {
        return this.page.htmlSourceTypeReplace ? UtilsService.indexableTypeContainsKey(this.page.htmlSourceTypeReplace, 'product-menu') : false;
    }

    getItemComponent(type: string): Type<any> | null {
        return this.productMenuService.getProductMenuComponent(type);
    }
}
